import { useAppSelector } from '@application/store/useStore';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
export default function WorkOrderTabsHelpers() {
    const { unchangedWorkorder } = useAppSelector((state) => state.workorder);
    const [infoTabErrorBorderColor, setInfoTabErrorBorderColor] = useState(false);
    const [generalTabErrorBorderColor, setGeneralTabErrorBorderColor] = useState(false);
    const [technicalTabErrorBorderColor, setTechnicalTabErrorBorderColor] = useState(false);
    const [isInfoTabBold, setIsInfoTabBold] = useState(false);
    const [isGeneralTabBold, setIsGeneralTabBold] = useState(false);
    const [isTechnicalDataTabBold, setIsTechnicalDataTabBold] = useState(false);
    const [isNotesTabBold, setIsNotesTabBold] = useState(false);
    const [formData, setFormData] = useState({
        id: 0,
        workOrderNumber: '',
        orderDate: new Date(),
        workCategoryId: 0,
        debtorId: 0,
        clientOrderNumber: '',
        clientContactPersonId: 0,
        clientPhoneNumber: '',
        clientEmail: '',
        appointments: '',
        statusId: 0,
        quantity: 1,
        assignment: '',
        description: '',
        objectClientReference: '',
        objectBrand: '',
        objectType: '',
        objectSerialNumber: '',
        objectVoltage: '',
        objectCurrent: '',
        objectPower: '',
        objectRpm: '',
        objectExtraData: '',
        deliveryNoteNumber: '',
        technicalCompletionDate: null,
        urgent: false,
        warranty: false,
        tpSameAsClientVisitAddress: false,
        tpLocation: '',
        tpDate: undefined,
        tpTiming: '',
        tpMechanic: '',
        created: new Date(),
        createdBy: '',
        modified: new Date(),
        modifiedBy: '',
        projectManagerId: 0,
        mechanicID: 0,
        workshopLocationId: 0,
        isObjectInside: false,
        desiredDeliveryDate: new Date(),
        quotation: false,
        objectInside: new Date(),
        smalljob: false,
        isOrderDate: false,
        note: '',
        workOrderFormData: '',
        debtorName: '',
        workOrderQuotation: null
    });
    const [errors, setErrors] = useState({
        workOrderNumber: '',
        orderDate: '',
        manualDate: '',
        manualOrderDate: '',
        workCategoryId: '',
        debtorId: '',
        clientOrderNumber: '',
        clientContactPerson: '',
        clientContactPersonId: '',
        clientPhoneNumber: '',
        clientEmail: '',
        appointments: '',
        statusId: '',
        quantity: '',
        desiredDeliveryDate: '',
        assignment: '',
        description: '',
        objectInside: '',
        objectClientReference: '',
        objectBrand: '',
        objectType: '',
        objectSerialNumber: '',
        objectVoltage: '',
        objectCurrent: '',
        objectPower: '',
        objectRpm: '',
        objectExtraData: '',
        deliveryNoteNumber: '',
        technicalCompletionDate: '',
        urgent: '',
        warranty: '',
        contactPerson: '',
        phoneNumber: '',
        tpSameAsClientVisitAddress: '',
        tpLocation: '',
        tpDate: '',
        tpTiming: '',
        tpMechanic: '',
        note: '',
        created: '',
        createdBy: '',
        modified: '',
        modifiedBy: '',
        projectManagerId: '',
        projectFreeText: '',
        mechanicID: '',
        workshopLocationId: '',
        debtorName: '',
        workOrderCategory: '',
        workOrderStatus: '',
        isObjectInside: '',
        quotation: '',
        smalljob: '',
        workOrderContactEmails: [],
    });
    const handleFieldChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: ''
        }));
    };
    useEffect(() => {
        if (!errors.workCategoryId && !errors.debtorId && !errors.clientOrderNumber && !errors.description && !errors.appointments) {
            setInfoTabErrorBorderColor(false);
        }
        if (!errors.clientContactPersonId &&
            !errors.clientPhoneNumber &&
            !errors.clientEmail &&
            !errors.workshopLocationId &&
            !errors.projectManagerId &&
            !errors.mechanicID &&
            errors.workOrderContactEmails.every(error => error === "")) {
            setGeneralTabErrorBorderColor(false);
        }
        if (!errors.description) {
            setTechnicalTabErrorBorderColor(false);
        }
    }, [errors]);
    useEffect(() => {
        checkBoldFields();
        checkunchangedWorkorderFields();
    }, [formData, unchangedWorkorder]);
    const handleToggelButtonChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
    };
    const handleCalendarChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
    };
    const handleTimeCalendarChange = (fieldName, value) => {
        const timeStringValue = value?.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: timeStringValue
        }));
    };
    const handleContactUpdate = (workOrderContacts, index) => {
        setFormData((prevData) => ({
            ...prevData,
            workOrderContact: workOrderContacts
        }));
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            // Check if errors exist before updating
            if (updatedErrors.workOrderContactEmails) {
                updatedErrors.workOrderContactEmails = [...updatedErrors.workOrderContactEmails];
                updatedErrors.workOrderContactEmails[index] = ""; // Remove error for specific index
            }
            return updatedErrors;
        });
    };
    const validateForm = () => {
        const newErrors = {
            workOrderNumber: '',
            orderDate: '',
            manualDate: '',
            manualOrderDate: '',
            workCategoryId: '',
            debtorId: '',
            clientOrderNumber: '',
            clientContactPerson: '',
            clientContactPersonId: '',
            clientPhoneNumber: '',
            clientEmail: '',
            appointments: '',
            statusId: '',
            quantity: '',
            desiredDeliveryDate: '',
            assignment: '',
            description: '',
            objectInside: '',
            objectClientReference: '',
            objectBrand: '',
            objectType: '',
            objectSerialNumber: '',
            objectVoltage: '',
            objectCurrent: '',
            objectPower: '',
            objectRpm: '',
            objectExtraData: '',
            deliveryNoteNumber: '',
            technicalCompletionDate: '',
            urgent: '',
            warranty: '',
            contactPerson: '',
            phoneNumber: '',
            tpSameAsClientVisitAddress: '',
            tpLocation: '',
            tpDate: '',
            tpTiming: '',
            tpMechanic: '',
            note: '',
            created: '',
            createdBy: '',
            modified: '',
            modifiedBy: '',
            projectManagerId: '',
            projectFreeText: '',
            mechanicID: '',
            workshopLocationId: '',
            debtorName: '',
            workOrderCategory: '',
            workOrderStatus: '',
            isObjectInside: '',
            quotation: '',
            smalljob: '',
            workOrderContactEmails: []
        };
        // ------------------------ InfoForm
        if (!formData.workOrderNumber.trim()) {
            newErrors.workOrderNumber = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (formData.workCategoryId <= 0) {
            newErrors.workCategoryId = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (formData.debtorId <= 0) {
            newErrors.debtorId = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (!formData.clientOrderNumber?.trim()) {
            newErrors.clientOrderNumber = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (!formData.description.trim() || formData.description.trim() === '' || formData.description === '0') {
            newErrors.description = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
            setTechnicalTabErrorBorderColor(true);
        }
        // if (!formData.appointments?.trim()) {
        //     newErrors.appointments = 'Dit veld is verplicht';
        //     setInfoTabErrorBorderColor(true);
        // }
        // ------------------------ GeneralForm
        // if ((formData.clientContactPersonId ?? 0) <= 0) {
        //     formData.clientContactPersonId = undefined
        // }
        // if ((formData.clientContactPersonId ?? 0) <= 0) {
        //     newErrors.clientContactPersonId = 'Dit veld is verplicht';
        //     setGeneralTabErrorBorderColor(true);
        // }
        // if (!formData.clientPhoneNumber?.trim()) {
        //     newErrors.clientPhoneNumber = 'Dit veld is verplicht';
        //     setGeneralTabErrorBorderColor(true);
        // }
        if ((formData.workshopLocationId ?? 0) <= 0) {
            newErrors.workshopLocationId = 'Dit veld is verplicht';
            setGeneralTabErrorBorderColor(true);
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (formData.clientEmail && !emailRegex.test(formData.clientEmail)) {
            newErrors.clientEmail = 'Ongeldig e-mailadres';
            setGeneralTabErrorBorderColor(true);
        }
        const workOrderContactErrors = formData.workOrderContact?.map((contact) => {
            return contact.email && !emailRegex.test(contact.email) ? 'Ongeldig e-mailadres' : '';
        }) ?? [];
        if (workOrderContactErrors.some(error => error)) {
            newErrors.workOrderContactEmails = workOrderContactErrors;
            setGeneralTabErrorBorderColor(true);
        }
        // if ((formData.projectManagerId ?? 0) <= 0) {
        //     newErrors.projectManagerId = 'Dit veld is verplicht';
        //     setGeneralTabErrorBorderColor(true);
        // }
        // if ((formData.mechanicID ?? 0) <= 0) {
        //     newErrors.mechanicID = 'Dit veld is verplicht';
        //     setGeneralTabErrorBorderColor(true);
        // }
        setErrors(newErrors);
        return newErrors;
    };
    //-------------------------Unsaved Tab Data Functionality-------------------------------
    const [isInfoTabUnsaved, setInfoTabUnsaved] = useState(false);
    const [isGeneralTabUnsaved, setGeneralTabUnsaved] = useState(false);
    const [isTechnicalTabUnsaved, setTechnicalTabUnsaved] = useState(false);
    const [isNotitiesTabUnsaved, setNotitiesTabUnsaved] = useState(false);
    const { id } = useParams();
    const checkunchangedWorkorderFields = () => {
        if (unchangedWorkorder && formData && id) {
            let isInfoTabUnsaved = false;
            let isGeneralTabUnsaved = false;
            let isTechnicalTabUnsaved = false;
            let isNotitiesTabUnsaved = false;
            // Check for unsaved changes in the Info tab
            if (unchangedWorkorder.workCategoryId !== formData.workCategoryId ||
                unchangedWorkorder.debtorId !== formData.debtorId ||
                unchangedWorkorder.clientOrderNumber !== formData.clientOrderNumber ||
                unchangedWorkorder.description !== formData.description ||
                unchangedWorkorder.assignment != formData.assignment ||
                unchangedWorkorder.isObjectInside != formData.isObjectInside ||
                unchangedWorkorder.isOrderDate != formData.isOrderDate ||
                unchangedWorkorder.technicalCompletionDate != formData.technicalCompletionDate) {
                isInfoTabUnsaved = true;
            }
            // Check for unsaved changes in the General tab
            if (unchangedWorkorder.clientContactPersonId !== formData.clientContactPersonId ||
                unchangedWorkorder.clientPhoneNumber !== formData.clientPhoneNumber ||
                unchangedWorkorder.clientEmail !== formData.clientEmail ||
                unchangedWorkorder.workshopLocationId !== formData.workshopLocationId ||
                unchangedWorkorder.projectManagerId !== formData.projectManagerId ||
                unchangedWorkorder.mechanicID !== formData.mechanicID ||
                unchangedWorkorder.tpSameAsClientVisitAddress !== formData.tpSameAsClientVisitAddress ||
                unchangedWorkorder.tpLocation !== formData.tpLocation ||
                unchangedWorkorder.tpTiming !== formData.tpTiming ||
                unchangedWorkorder.tpMechanic !== formData.tpMechanic ||
                unchangedWorkorder.tpDate !== formData.tpDate ||
                unchangedWorkorder.appointments != formData.appointments ||
                unchangedWorkorder.urgent != formData.urgent ||
                unchangedWorkorder.quotation != formData.quotation ||
                unchangedWorkorder.warranty != formData.warranty ||
                unchangedWorkorder.workOrderContact != formData.workOrderContact) {
                isGeneralTabUnsaved = true;
            }
            // Check for unsaved changes in the Technical tab
            if (formData.quantity !== unchangedWorkorder.quantity ||
                formData.objectClientReference !== unchangedWorkorder.objectClientReference ||
                formData.description !== unchangedWorkorder.description ||
                formData.objectBrand !== unchangedWorkorder.objectBrand ||
                formData.objectType !== unchangedWorkorder.objectType ||
                formData.objectSerialNumber !== unchangedWorkorder.objectSerialNumber ||
                formData.objectVoltage !== unchangedWorkorder.objectVoltage ||
                formData.objectCurrent !== unchangedWorkorder.objectCurrent ||
                formData.objectPower !== unchangedWorkorder.objectPower ||
                formData.objectRpm !== unchangedWorkorder.objectRpm ||
                formData.objectExtraData !== unchangedWorkorder.objectExtraData) {
                isTechnicalTabUnsaved = true;
            }
            // Check for unsaved changes in the Notities tab
            if (unchangedWorkorder.note !== formData.note) {
                isNotitiesTabUnsaved = true;
            }
            // Set unsaved state for all tabs
            setInfoTabUnsaved(isInfoTabUnsaved);
            setGeneralTabUnsaved(isGeneralTabUnsaved);
            setTechnicalTabUnsaved(isTechnicalTabUnsaved);
            setNotitiesTabUnsaved(isNotitiesTabUnsaved);
        }
    };
    const checkBoldFields = () => {
        if (formData.workOrderNumber || formData.workCategoryId || formData.debtorId || formData.clientOrderNumber || formData.description || formData.assignment || formData.isObjectInside == true || formData.isOrderDate == true
            || formData.technicalCompletionDate) {
            setIsInfoTabBold(true);
        }
        if (formData.desiredDeliveryDate || formData.clientContactPersonId || formData.clientPhoneNumber || formData.workshopLocationId || formData.projectManagerId || formData.mechanicID || formData.appointments || formData.urgent == true
            || formData.quotation == true || formData.warranty == true || formData.tpSameAsClientVisitAddress || formData.tpLocation || formData.tpDate || formData.tpTiming || formData.tpMechanic) {
            setIsGeneralTabBold(true);
        }
        if (formData.quantity || formData.objectClientReference || formData.description || formData.objectBrand || formData.objectType || formData.objectSerialNumber || formData.objectCurrent
            || formData.objectPower || formData.objectRpm || formData.objectVoltage || formData.objectExtraData) {
            setIsTechnicalDataTabBold(true);
        }
        if (formData.note) {
            setIsNotesTabBold(true);
        }
        else {
            setIsNotesTabBold(false);
        }
    };
    return {
        handleFieldChange,
        handleToggelButtonChange,
        handleCalendarChange,
        handleTimeCalendarChange,
        handleContactUpdate,
        validateForm,
        formData,
        setFormData,
        errors,
        infoTabErrorBorderColor,
        generalTabErrorBorderColor,
        technicalTabErrorBorderColor,
        isInfoTabBold,
        isGeneralTabBold,
        isTechnicalDataTabBold,
        isNotesTabBold,
        isNotitiesTabUnsaved,
        isTechnicalTabUnsaved,
        isGeneralTabUnsaved,
        isInfoTabUnsaved
    };
}
